/* *
 * ========================================================================
 * Vortex Solution
 * ========================================================================
 * */

// Includes the custom Modernizr build based on the configurations set in .modernizrrc
require('./modernizr');
require('nodelist-foreach-polyfill');
require('element-qsa-scope');
require('./main/dropdown-menu');
require('./main/mobile-menu');
require('./main/user-is-tabbing');
require('./main/forms');
require('./main/breadcrumbs');
require('./main/header');
require('./main/search');
require('./main/search-bar');
require('./main/sidebar-navigation');
require('./main/alert-bar');
require('./main/programs-courses-listing');
require('./main/hero-swiper');
require('./main/links-identifier');
require('./common/tab-hash');

console.log(
  'This is a test alert to check if the JavaScript file is working correctly. Please remove this line after confirming.'
);

import 'bootstrap/dist/js/bootstrap.bundle';
